import { PlusIcon } from "@heroicons/react/20/solid";
import { Button } from "@metatrustlabs/ui-base";
import { CSSProperties, FC, ReactNode } from "react";
import { TooltipRenderProps } from "react-joyride";
import { OnboardingStep } from "./OnboardingTour";

interface OnboardingTooltipProps extends TooltipRenderProps {
  step: OnboardingStep;
  style?: CSSProperties; // 容器样式
  nextButtonText?: string; // “下一步”按钮的文字
  showProgress?: boolean; // 是否显示进度
  progress?: ((index: number, size: number) => ReactNode) | ReactNode; // 进度文字
}

const OnboardingTooltip: FC<OnboardingTooltipProps> = ({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  skipProps,
  size,
  style,
  showProgress = true,
  nextButtonText,
  isLastStep,
  progress,
}) => {
  let progressNode: ReactNode = `${index + 1}/${size}`;
  if (progress) {
    if (typeof progress === "function") {
      progressNode = progress(index, size);
    } else {
      progressNode = progress;
    }
  }

  return (
    <div
      style={style}
      className="rounded-md bg-gray-50 py-8 px-12 text-gray-800"
      {...tooltipProps}
    >
      {!step.hideCloseButton && (
        <button {...skipProps} className="absolute right-12">
          <PlusIcon className="h-6 w-6 rotate-45 text-gray-400" />
        </button>
      )}

      {step.title && <div className="text-left font-bold">{step.title}</div>}
      <div className="py-6 text-left">{step.content}</div>
      <div className="flex justify-end gap-x-4">
        {index === 0 && !step.hideSkipButton && (
          <Button intent="secondary" className="min-w-[7rem]" {...skipProps}>
            No, thanks
          </Button>
        )}
        {index > 0 && !step.hideBackButton && (
          <Button className="min-w-[7rem]" {...backProps}>
            Previous
          </Button>
        )}
        {continuous && (
          <Button intent="highlight" className="min-w-[7rem]" {...primaryProps}>
            {step.nextButtonText ||
              (nextButtonText ? nextButtonText : isLastStep ? "OK" : "Next")}
          </Button>
        )}
      </div>
      {showProgress && size > -1 && (
        <div className="absolute left-12 bottom-9 text-sm text-gray-700">
          {progressNode}
        </div>
      )}
    </div>
  );
};

export default OnboardingTooltip;
